import { useEffect } from 'react';
import { getScrollStorage, updateScrollStorage } from 'utils/storage';
import { useLocation } from 'react-router-dom';
import { global } from 'config/Routes';

//memo: pushRoutingとreplaceRoutingで画面遷移した際に
//      heightの引数があれば、sessionStorageのscrollにデータが登録される。
//      データが登録されている状態でuseScrollを実行すればスクロールされるが
//      画面表示が終わった後に実行されないとスクロールされない。

export const useScroll = () => {
  const location = useLocation();
  const path = location.pathname;
  const queryString = window.location.search;

  useEffect(() => {
    const timer = setTimeout(() => {
      const scrollList = getScrollStorage();
      if (scrollList === null || scrollList.length === 0) return;

      const currentItem = scrollList.find(
        storage => storage.path === path || storage.path === path + queryString
      );
      const height = currentItem === undefined ? 0 : currentItem.height || 0;

      const newScrollStorage = scrollList.filter(list => list.path !== path);
      updateScrollStorage(newScrollStorage);

      if (height !== 0) window.scrollTo(0, height);

      const globalPath = global.map(global => global.path);
      const isGlobal = globalPath.includes(path);
      if (isGlobal) {
        // memo: Gナビの画面に来た場合はリセットする。
        updateScrollStorage([]);
      }
    }, 1500);

    return () => {
      clearTimeout(timer);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
